class Config{}

Config.ACCESS_TOKEN = 'ACCESS_TOKEN';
Config.DEBUG_LEVEL = 0;
Config.LOGIN_PAGE = 'http://localhost:8085';

export default Config;

